import React, { Component } from 'react';
import PropTypes from 'prop-types';

import InfoDialog from './InfoDialog';
import WarningDialog from './WarningDialog';
import ErrorDialog from './ErrorDialog';
import SuccessDialog from './SuccessDialog';
import CustomDialog from './CustomDialog';
import WithFormDialog from './WithFormDialog';
import ScrollableDialog from './ScrollableDialog';

class DialogManager extends Component {
	render() {
		const components = {
			success: SuccessDialog,
			info: InfoDialog,
			warning: WarningDialog,
			error: ErrorDialog,
			custom: CustomDialog,
			withForm: WithFormDialog,
			scrollable: ScrollableDialog,
		};
		const { type, ...props } = this.props;

		const RenderDialog = components[type] || 'info';
		return <RenderDialog {...props} />;
	}
}

export default DialogManager;

DialogManager.defaultProps = {
	cancelBtnText: 'Cancel',
	confirmBtnText: 'Ok',
};

DialogManager.propTypes = {
	type: PropTypes.oneOf([
		'success',
		'info',
		'warning',
		'error',
		'custom',
		'withForm',
		'scrollable',
	]).isRequired,
	title: PropTypes.string,
	message: PropTypes.node,
	children: PropTypes.any,
	onConfirm: PropTypes.func,
	onCancel: PropTypes.func,
	confirmBtnText: PropTypes.string,
	cancelBtnText: PropTypes.string,
	showIcon: PropTypes.bool,
	maxWidth: PropTypes.string,
	confirmBtnColor: PropTypes.string,
	cancelBtnColor: PropTypes.string,
};
